<template lang="jade" src="../_partials/button.jade"></template>
<script>
  import { Submit } from 'src/services/resources'
  import buttons from '../_shared/traits'

  export default {
    data: () => ({}),
    mixins: [buttons],
    methods: {
      click (action) {
        this.back()
      },
      /**
       * Back button press.
       * Send to the submit endpoint and the API will send the fragment back to
       * the correct place.
       */
      back () {
        this.proccessing = true
        Submit.post({button: this.fdata.buttonId}, this.headers)
          .then(this.success)
          .catch(this.failed)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// back.vue?4b1ed9d4